var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-6",attrs:{"flat":""}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('institution.jiscNotRequesting'))+" ")]),_c('v-btn',{attrs:{"disabled":_vm.disableSendToConsortium,"color":"primary","loading":_vm.isLoading},on:{"click":_vm.sendToConsortium}},[_vm._v(" "+_vm._s(_vm.$t('scenarioPushPull.sendToConsortium'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }